import { call, put, takeLatest } from 'redux-saga/effects';

import { composeEmailActions } from '../actions/composeEmailActions';
import * as composeEmailAPI from '../api/composeEmail';

export const {
  composeEmailFindUser,
  composeEmailFindUserSucceeded,
  composeEmailFindUserFailed,
  composeEmailGetAllFrom,
  composeEmailGetAllFromSucceeded,
  composeEmailGetAllFromFailed,
} = composeEmailActions;

export const composeEmail = [
  takeLatest(
    composeEmailFindUser.toString() as any,
    genWithPromise(
      composeEmailAPI.findUser,
      composeEmailFindUserSucceeded,
      composeEmailFindUserFailed,
    ),
  ),
  takeLatest(
    composeEmailGetAllFrom.toString() as any,
    genWithPromise(
      composeEmailAPI.getAllFrom,
      composeEmailGetAllFromSucceeded,
      composeEmailGetAllFromFailed,
    ),
  ),
];

function genWithPromise(
  apiAction: (action: any) => any,
  resultSucceededAction: (result: any) => any,
  resultFailedAction: (result: any) => any,
) {
  return function* (action: {
    payload: any;
    meta: { resolve: () => void; reject: () => void };
  }) {
    let result;

    try {
      result = yield call(apiAction, action.payload);
      yield call(action.meta.resolve as any, result);
      yield put(resultSucceededAction(result));
    } catch (exception) {
      console.warn(exception);
      // Something went wrong. We reject the promise.
      yield call(action.meta.reject as any, exception);
      result = exception;
      yield put(resultFailedAction(result));
    }
  };
}
